import { graphAtom } from "@features/run/RunGroupDialog/atoms"
import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { FormControl, FormHelperText, TextField } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import { getErrorMessage } from "@utils/form"
import { useAtomValue } from "jotai"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldEndDate = () => {
  const graph = useAtomValue(graphAtom)
  const {
    control,
    formState: { errors },
  } = useFormContext<RunGroupFormValues>()

  if (!graph) return null

  return (
    <Controller
      name="end_date"
      control={control}
      render={({ field }) =>
        field.value === "rolling" ? (
          <TextField
            error={Boolean(errors[field.name])}
            helperText={getErrorMessage(errors, field.name)}
            label="End date"
            variant="standard"
            disabled
            {...field}
          />
        ) : (
          <FormControl variant="standard" error={Boolean(errors[field.name])}>
            <DatePicker
              label="End date"
              format="yyyy-MM-dd"
              minDate={new Date(graph.start_date)}
              slotProps={{ textField: { variant: "standard" } }}
              {...field}
            />
            {graph.end_date !== "rolling" && (
              <FormHelperText error={false}>
                Between {graph.start_date} (graph start-date) and {graph.end_date} (graph end-date)
              </FormHelperText>
            )}
            {!!errors.end_date?.message?.length && (
              <FormHelperText error>{`- ${getErrorMessage(errors, field.name)}`}</FormHelperText>
            )}
          </FormControl>
        )
      }
    />
  )
}
